import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const AreaChart = ({ InhouseMemberData, chartData }) => {
  const [loading, setLoading] = useState(true);
  const [maxY, setMaxY] = useState(0);
  useEffect(() => {
    setMaxY(
      Math.max.apply(
        Math,
        chartData.map((each) => each.total)
      )
    );
    setLoading(false);
  }, []);
  const series = [
    {
      name: "Total Checkins",
      data:
        InhouseMemberData.length !== 0
          ? InhouseMemberData.map((each) => each.count)
          : [0, 0],
    },
  ];
  const options = {
    chart: {
      type: "area",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    xaxis: {
      categories:
        InhouseMemberData.length !== 0
          ? InhouseMemberData.map(
              (each) => `${each.hour} - ${Number(each.hour) + 1}`
            )
          : [0, 0],
      title: {
        text: "Time(hrs)",
      },
    },
    yaxis: {
      title: {
        text: "",
      },
      min: 0,
      max: maxY,
    },
  };
  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={options}
          series={series}
          type="area"
          height={350}
        />
      </div>
    </div>
  );
};

export default AreaChart;
